import { appShellTheme } from './app-shell';
import { buttonTheme } from './button';
import { cardTheme } from './card';
import { checkboxTheme } from './checkbox';
import { drawerTheme } from './drawer';
import { emptyStateTheme } from './emptyState';
import { formLabelTheme } from './formLabel';
import { headingTheme } from './heading';
import { inputTheme } from './input';
import { linkTheme } from './link';
import { modalTheme } from './modal';
import { pageTheme } from './page';
import { spinnerTheme } from './spinner';
import { switchTheme } from './switch';
import { textTheme } from './text';
import { toolbarTheme } from './toolbar';

export const components = {
  Input: inputTheme,
  Card: cardTheme,
  SuiAppShell: appShellTheme,
  SuiToolbar: toolbarTheme,
  SuiPage: pageTheme,
  Text: textTheme,
  Heading: headingTheme,
  Modal: modalTheme,
  Drawer: drawerTheme,
  Switch: switchTheme,
  Checkbox: checkboxTheme,
  Spinner: spinnerTheme,
  SuiEmptyState: emptyStateTheme,
  Link: linkTheme,
  Button: buttonTheme,
  FormLabel: formLabelTheme,
};
